var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.57895 7.2V12L0 6L7.57895 0V4.8H13.8947C16.5748 4.8 19.1451 5.81143 21.0402 7.61178C22.9353 9.41212 24 11.8539 24 14.4C24 16.9461 22.9353 19.3879 21.0402 21.1882C19.1451 22.9886 16.5748 24 13.8947 24H2.52632V21.6H13.8947C15.9048 21.6 17.8325 20.8414 19.2539 19.4912C20.6752 18.1409 21.4737 16.3096 21.4737 14.4C21.4737 12.4904 20.6752 10.6591 19.2539 9.30883C17.8325 7.95857 15.9048 7.2 13.8947 7.2H7.57895Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestart);
export default __webpack_public_path__ + "static/media/restart.0348647a7dae743f139d281193d1d372.svg";
export { ForwardRef as ReactComponent };